import React from "react";
import { Card, CardBody } from "reactstrap";
import SparkLineGraph from "./SparkLineGraph";
import InfoCardImage from "./InfoCardImage";

export const MobileInfoCard = ({
  label,
  units,
  value,
  defaultValue = "N/A",
  valueFontSize = "1rem",
  subLabel = null,
  sparklineData = null,
}) => {
  const valueStyle = {
    float: "right",
    fontWeight: 300,
    fontSize: valueFontSize,
    color: "var(--brand-green)"
  };
  const labelStyle = {
    fontSize: "small"
  }

  const sparkValues = Array.isArray(sparklineData)
    ? sparklineData.map((point) => point.value)
    : [];

  return (
    <Card
      className="shadow-sm border border-lt "
      style={{ margin: 0, width: "100%" }}
    >
      <CardBody className="py-3 d-flex flex-column align-items-center text-center">
        <div className="d-flex flex-column align-items-center text-center">
          <strong style={labelStyle}>{label}</strong>
        </div>

        <div>
          <span style={valueStyle}>
            {value ?? defaultValue}
          </span>
        </div>

        {sparkValues.length > 0 && (
          <div className="w-100 d-flex justify-content-center">
            <SparkLineGraph
              data={sparkValues}
              width={100}
              height={20}
              style={{ strokeWidth: 1, fill: "none" }}
              className="sparkline-wrapper"
            />
          </div>
        )}

      </CardBody>
    </Card>

  );
};

const InfoCard = ({
  label,
  units,
  value,
  defaultValue = "N/A",
  valueFontSize = "2rem",
  subLabel = null,
  sparklineData = null,
  selectedImagePath = null,
  imageDesc = "description"

}) => {
  const valueStyle = {
    float: "right",
    fontWeight: 300,
    fontSize: valueFontSize,
    color: "var(--brand-green)"
  };

  const sparkValues = Array.isArray(sparklineData)
    ? sparklineData.map((point) => point.value)
    : [];

  return (
    <Card className="mb-3 shadow-sm border border-lt">
      <CardBody className="py-3">
        <div className="info-card-row">
          {selectedImagePath &&
            <div>
              <InfoCardImage src={selectedImagePath} alt={imageDesc} maxHeight={100} />
            </div>
          }
          <div className="info-card-content">
            <div>
              <strong>{label}</strong>{" "}
              <span className="text-muted small" >{units}</span>
              <span style={valueStyle}>
                {value ?? defaultValue}
              </span>
            </div>
            {sparkValues.length > 0 && (
              <SparkLineGraph
                data={sparkValues}
                width={100}
                height={20}
                style={{ strokeWidth: 1, fill: "none" }}
                className="sparkline-wrapper"
              />
            )}
            {subLabel && <div className="text-muted small mt-1">⏱ {subLabel}</div>}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default InfoCard;
